module.exports = __webpack_public_path__ + "img/performance_ts.54196a76.png";